// Environment variables helper for Vite
export const TENANT_ID = import.meta.env.VITE_AAD_TENANT_ID;
export const SPA_CLIENT_ID = import.meta.env.VITE_AAD_SPA_CLIENT_ID;
export const REDIRECT_URI = import.meta.env.VITE_AAD_REDIRECT_URI;
export const POST_LOGOUT_URI = import.meta.env.VITE_AAD_POST_LOGOUT_URI;
export const VITE_ENTRA_APP_ID_URI = import.meta.env.VITE_ENTRA_APP_ID_URI;
export const PROXY_TARGET_BOOKING = import.meta.env.VITE_PROXY_TARGET_BOOKING;
export const ENABLE_MOCK_AUTH =
  (import.meta.env.VITE_ENABLE_MOCK_AUTH ?? "false") === "true";
export const ALLOW_MOCK_AUTH_IN_PROD =
  (import.meta.env.VITE_ALLOW_MOCK_AUTH_IN_PROD ?? "false") === "true";

// Sentry
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? "";
export const SENTRY_ENVIRONMENT =
  import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE;
